import React from "react";
import BusinessProfile from "../components/business/BusinessProfile";

function BusinessProfilePage() {
  return <BusinessProfile />;
}

export default BusinessProfilePage;
